// extracted by mini-css-extract-plugin
var _1 = "p0tfXdmnl5gBh3qhYMN0";
var _2 = "EcBvQLEk1AEhjOUvpBH4";
var _3 = "EIu6lRT67JY97WZ7hXdB";
var _4 = "sAcPuU4pewI77C5x3qnO";
var _5 = "DpXO31Mbt4cEHckxr6nL";
var _6 = "DpXO31Mbt4cEHckxr6nL";
var _7 = "p0tfXdmnl5gBh3qhYMN0";
var _8 = "EcBvQLEk1AEhjOUvpBH4";
var _9 = "EIu6lRT67JY97WZ7hXdB";
var _a = "Zk1XcwyZPgNmFwGD31Ma";
var _b = "Ys4dqX3osMIlkbhJUg7o";
var _c = "Ys4dqX3osMIlkbhJUg7o";
var _d = "dZ2ZgdBLldMKnpqT60i6";
var _e = "NDlDs1C0KKcgoj70uY7Q";
var _f = "NDlDs1C0KKcgoj70uY7Q";
var _10 = "VlxL6Zbgn04jQ6HFDOo0";
var _11 = "VlxL6Zbgn04jQ6HFDOo0";
export { _1 as "ExtenalPlugin", _2 as "ExtenalPluginContainer", _3 as "ExtenalPluginIcon", _4 as "container", _5 as "container-sidenav", _6 as "containerSidenav", _7 as "extenalPlugin", _8 as "extenalPluginContainer", _9 as "extenalPluginIcon", _a as "flex", _b as "general-dashboard", _c as "generalDashboard", _d as "navbar", _e as "no-print", _f as "noPrint", _10 as "take-chat", _11 as "takeChat" }
